<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sGYZNM/tc-custom/9781451637243.jpg?1730493387866" alt="This image is the cover for the book Fallen Hearts, Casteel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fallen Hearts, Casteel
      </h1>
      <p class="bookDescription body article font2">
        <b>Heaven is home as the #1 <i>New York Times</i>–bestselling author of <i>Flowers in the Attic</i> continues the Casteel family saga—now a Lifetime movie series event.</b><br/><br/>Proud and beautiful, Heaven came back to the hills—to rise at last above her family’s shame.<br/><br/>As Logan’s bride, Heaven would savor now the love she had sought for so long. And free from her father’s clutches, she would live again in her backwoods town, a respected teacher and cherished wife. But after a wedding trip to Boston’s Farthinggale Manor and a lavish, elegant party, Heaven and Logan are persuaded to stay . . . lured by Tony Tatterton’s guile to live amidst the Tatterton wealth and privilege. Then the ghosts of Heaven’s past rise up once more, writhing around her fragile happiness . . . threatening her precious love with scandal and jealousy, sinister passions, and dangerous dreams.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        V. C. Andrews
      </h2>
      
      <p class="authorDescription body article">One of the most popular authors of all time,&#160;V.C. Andrews&#160;has been a bestselling phenomenon since the publication of&#160;<I>Flowers in the Attic</I>, first in the renowned Dollanganger family series, which includes&#160;<I>Petals on the Wind</I>,&#160;<I>If There Be Thorns</I>,&#160;<I>Seeds of Yesterday</I>, and&#160;<I>Garden of Shadows</I>. The family saga continues with&#160;<I>Christopher&rsquo;s Diary: Secrets of Foxworth</I>,&#160;<I>Christopher&rsquo;s Diary: Echoes of Dollanganger</I>, and&#160;<I>Secret Brother</I>, as well as&#160;<I>Beneath the Attic</I>,&#160;<I>Out of the Attic</I>, and&#160;<I>Shadows of Foxworth&#160;</I>as part of the fortieth anniversary celebration. There are more than ninety V.C. Andrews novels, which have sold over 107 million copies worldwide and have been translated into more than twenty-five foreign languages.&#160;Andrews&rsquo;s life story is told in <I>The Woman Beyond the Attic</I>.&#160;Join the conversation about the world of V.C. Andrews at Facebook.com/OfficialVCAndrews.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d5e5ee50